import { resolveLocalizedMessage, type LocalizedMessage } from "./localized-message"
import { useLocalization } from "./localization-provider"

/** Resolves stored UI metadata during rendering, including after a culture change. */
export function LocalizedText({ value }: { value: string | LocalizedMessage }) {
  const localization = useLocalization()
  return resolveLocalizedMessage(localization.i18n, value)
}
